import { useState, useCallback } from "react";
import { useAuth } from "src/contexts/auth-provider";
import { useAxiosInterceptor } from "src/hooks/useAxiosInterceptor";
import { GRAPHQL_ENDPOINT } from "src/constants/endpoints";
import { GET_CHANNELS } from "src/constants/queries";
import { failureToast } from "src/utils/toasts";
import { Channel } from "src/interfaces/channel.interface";

export const useChannels = () => {
  const { axBe } = useAxiosInterceptor();
  const { hasRestaurant } = useAuth();
  const [channels, setChannels] = useState<Channel[]>([]);
  const [isLoadingChannels, setIsLoadingChannels] = useState(false);

  const fetchChannels = useCallback(async () => {
    if (!hasRestaurant?.correlationId) return;

    setIsLoadingChannels(true);

    try {
      const { data } = await axBe.post(GRAPHQL_ENDPOINT, {
        query: GET_CHANNELS,
        variables: {
          storeCorrelationId: hasRestaurant.correlationId,
        },
      });

      if (data?.data?.channels) {
        setChannels(data.data.channels);
      }
    } catch (err) {
      console.error("Error fetching channels:", err);
      failureToast("Failed to fetch channels");
    } finally {
      setIsLoadingChannels(false);
    }
  }, [axBe, hasRestaurant?.correlationId]);

  return {
    channels,
    isLoadingChannels,
    fetchChannels,
  };
};

